import Translations from "../../translations.json";

export type TranslationKey = keyof typeof Translations;

export function createTranslator(getLocale: () => string) {
  return (phraseKey: TranslationKey): string => {
    const locale = getLocale();
    const phrase = Translations[phraseKey];

    if (locale in phrase) {
      return (phrase as any)[locale];
    }

    return phrase.en;
  };
}
